import { type UseQueryOptions, useQuery } from "@tanstack/react-query";

import { getPlace } from "@/customer-info/api/getPlace";
import { useLogger } from "@/sdk";

export type UseTimezoneData = string | undefined;
export type UseTimezoneOptions = Partial<UseQueryOptions<UseTimezoneData, Error, UseTimezoneData, string[]>>;

export function useTimezone(searchText: string, options?: UseTimezoneOptions) {
    const logger = useLogger({ module: "useTimezone", supportTeam: "sales" });
    return useQuery({
        queryKey: ["use-timezone", searchText],
        queryFn: async ({ queryKey: [_key, text] }): Promise<UseTimezoneData> => {
            const response = await getPlace(logger, text);

            return response?.Results?.[0]?.Place?.TimeZone?.Name;
        },
        ...options,
    });
}
